import { render, staticRenderFns } from "./StaggeringTransition.vue?vue&type=template&id=007318c6&"
import script from "./StaggeringTransition.vue?vue&type=script&lang=js&"
export * from "./StaggeringTransition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports